import React from 'react';
import styled from '@emotion/styled';
import Image from 'next/image';

const text = {
  title: '일반회원가입 ',
  identification: '본인확인 ',
  requestVerify: '인증요청 ',
  confirmVerify: '인증완료 ',
  email: '이메일 ',
  password: '비밀번호 ',
  passwordConfirm: '비밀번호 확인 ',
};

export const RequiredComponent = (props) => {
  const { values, bottomText, handleSignupChange } = props;
  return (
    <RequiredContainer>
      <Title>{text.title}</Title>
      <MobileInputTitle>
        {text.email}
        <Image src='/red_dot.png' alt='red_dot' width={5} height={5} />
      </MobileInputTitle>
      <InfoWarp>
        <InputTitle>
          {text.email}
          <Image src='/red_dot.png' alt='red_dot' width={5} height={5} />
        </InputTitle>
        <InfoInput
          placeholder='example@legalengine.co.kr'
          name='email'
          type='email'
          autoComplete='off'
          value={values.email}
          onChange={handleSignupChange}
        />
      </InfoWarp>
      <BottomTextWarp>
        {!values.existEmail ? (
          <BottomText>{bottomText.email}</BottomText>
        ) : (
          <BottomWarningText>{bottomText.email}</BottomWarningText>
        )}
      </BottomTextWarp>
      <MobileInputTitle>
        {text.password}
        <Image src='/red_dot.png' alt='red_dot' width={5} height={5} />
      </MobileInputTitle>
      <InfoWarp>
        <InputTitle>
          {text.password}
          <Image src='/red_dot.png' alt='red_dot' width={5} height={5} />
        </InputTitle>
        <InfoInput
          placeholder='영어 소문자+숫자, 10자 이상'
          name='password'
          type='password'
          value={values.password}
          autoComplete='new-password'
          onChange={handleSignupChange}
        />
      </InfoWarp>
      {values.password.length > 0 ? (
        <BottomTextWarp>
          <BottomWarningText>{bottomText.password}</BottomWarningText>
        </BottomTextWarp>
      ) : null}
      <InfoWarp>
        <InputTitle>
          {text.passwordConfirm}
          <Image src='/red_dot.png' alt='red_dot' width={5} height={5} />
        </InputTitle>
        <InfoInput
          placeholder='비밀번호 재입력'
          name='passwordConfirm'
          type='password'
          autoComplete='new-password'
          value={values.passwordConfirm}
          onChange={handleSignupChange}
        />
      </InfoWarp>
      <BottomTextWarp>
        {values.passwordConfirm.length > 0 ? <BottomWarningText>{bottomText.passwordConfirm}</BottomWarningText> : null}
      </BottomTextWarp>
    </RequiredContainer>
  );
};

const RequiredContainer = styled.article`
  padding: 50px 0;
  border-bottom: 1px solid #c4c4c4;
`;

const Title = styled.header`
  text-align: center;
  font-weight: bold;
  font-size: 23px;
`;

const MobileInputTitle = styled.div`
  display: none;
  @media only screen and (max-width: 992px) {
    display: block;
    margin-top: 46px;
  }
`;

const InputTitle = styled.div`
  text-align: left;
  align-self: center;
  font-size: 18px;
  width: 20%;
  @media only screen and (max-width: 992px) {
    display: none;
  }
`;

const Input = styled.input`
  height: 50px;
  padding: 0 1rem;
  background-color: #ffffff;
  border: 1px solid #c4c4c4;
  box-sizing: border-box;
  ::placeholder {
    color: #c4c4c4;
  }
  :focus {
    border: 1px solid #002366;
  }
`;

const InfoWarp = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 46px;
  @media only screen and (max-width: 992px) {
    margin-top: 20px;
  }
`;

const InfoInput = styled(Input)`
  width: 80%;
  @media only screen and (max-width: 992px) {
    width: 100%;
  }
`;

const BottomTextWarp = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 10px;
`;

const BottomText = styled.span`
  font-size: 16px;
  width: 80%;
  color: #6f6f6f;
  text-align: left;
  @media only screen and (max-width: 992px) {
    width: 100%;
    font-size: 14px;
  }
`;

const BottomWarningText = styled(BottomText)`
  color: #dc3545;
`;

const BottomSuceessText = styled(BottomText)`
  color: #28a745;
`;

const Warning = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #dc3545;
  margin-top: 10px;
  margin-left: 20%;
  @media only screen and (max-width: 992px) {
    font-size: 14px;
  }
`;

const Success = styled(Warning)`
  color: #28a745;
`;
